import { defineComponent as _defineComponent } from 'vue'
import {useModalStore} from '@/components/L/Modal/useModalStore';
import {ModalInstance, ModalInstanceOld} from '@/components/L/Modal/ModalTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'LModal',
  setup(__props) {

const {modals, closeModal: closeModalInStore,} = useModalStore()
const submitModal = (modal: ModalInstance, payload?: unknown) => {
  closeDialog(modal);
  closeModalInStore(modal, payload);
}

const closeDialog = (modal: ModalInstance) => {
  const dialog = document.querySelector(`#dialog-${modal.uuid}`) as HTMLElement
  dialog.remove()
}

return { __sfc: true,modals, closeModalInStore, submitModal, closeDialog }
}

})